// extracted by mini-css-extract-plugin
export default {"main_container":"CountryList_main_container__wnCDh","back_arrow":"CountryList_back_arrow__sGpKJ","heading":"CountryList_heading__tZREi","full_name":"CountryList_full_name__iaoIK"};